export default __webpack_public_path__ + "./images/co.174ec67c.png";